export default {
  getWeeklyPeriodPricing: "weeklyPeriodPricing",
  createWeeklyPeriodPricing: "weeklyPeriodPricing/create",
  updateWeeklyPeriodPricing: "weeklyPeriodPricing/update",
  deleteWeeklyPeriodPricing: "weeklyPeriodPricing/delete",

  getWeeklyPeriodPricingDetail: "weeklyPeriodPricingDetail",
  createWeeklyPeriodPricingDetail: "weeklyPeriodPricingDetail/create",
  updateWeeklyPeriodPricingDetail: "weeklyPeriodPricingDetail/update",
  deleteWeeklyPeriodPricingDetail: "weeklyPeriodPricingDetail/delete",

  getEnergyDemandTarget: "energyDemandTarget",
  createEnergyDemandTarget: "energyDemandTarget/create",
  updateEnergyDemandTarget: "energyDemandTarget/update",
  deleteEnergyDemandTarget: "energyDemandTarget/delete",

  getConfig: "config",
  getConfigDetail: "config",
  createConfig: "config/create",
  updateConfig: "config/update",
  deleteConfig: "config/delete",
};
